import { cn } from "../../utils/utils";
import React from "react";
import { Controller } from "react-hook-form";
import styles from "./Styles.module.css";

// Memoized component
const CustomFormInput = ({
  control,
  name,
  label,
  type,
  errors,
  className,
  placeholder,
}) => {
  return (
    <div className={className}>
      <Controller
        control={control}
        name={name}
        render={({ field: { value, onChange } }) => {
          return (
            <div className={styles.formField}>
              <input
                tabIndex={-1}
                dir="ltr"
                value={value}
                type={type}
                onChange={onChange}
                placeholder={placeholder}
              />
              <span>
               <div className="flex gap-2  items-center">
                 {label}{" "}
                 {errors && (
                   <div className="text-red-500 text-sm">
                     {errors?.message}
                   </div>
                 )}
               </div>
              </span>
            </div>
          );
        }}
      />
    </div>
  );
};

export default CustomFormInput;
